// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ==========================================
   WHOIS PREMIUM RESULT DASHBOARD
========================================== */

.whois-lookup {
    padding: 25px !important;
    background: linear-gradient(145deg, #111827, #0b1220);
    border: 1px solid rgba(56,189,248,.15);
    border-radius: 16px;
    color: #e2e8f0;
    box-shadow: 0 12px 35px rgba(0,0,0,.2);
    font-family: Inter, Arial, sans-serif;
}

.whois-lookup h4 {
    color: #f8fafc;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 22px;
}

/* SEARCH INPUT */

.whois-lookup .input-group {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 10px;
    padding: 7px;
    background: #080f1c;
    border: 1px solid #334155;
    border-radius: 10px;
}

.whois-lookup .input-group .form-control {
    display: block !important;
    flex: 1 1 !important;
    width: 1% !important;
    min-width: 0 !important;
    height: 44px;
    padding: 0 14px;
    background: transparent !important;
    color: #fff !important;
    border: none !important;
    box-shadow: none !important;
}

.whois-lookup .form-control::placeholder {
    color: #64748b !important;
}

.whois-lookup .input-group .btn {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 110px;
    border: none;
    border-radius: 8px !important;
    background: linear-gradient(135deg,#0284c7,#2563eb);
    color: white;
    font-weight: 700;
}

/* RESULTS */

.whois-results {
    margin-top: 25px;
    animation: whoisFade .35s ease;
}

@keyframes whoisFade {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* ASN HERO */

.whois-asn-card {
    padding: 25px;
    border-radius: 13px;
    background: linear-gradient(120deg,#0c4a6e,#172554,#312e81);
    border: 1px solid rgba(56,189,248,.3);
    margin-bottom: 20px;
}

.whois-asn-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.whois-asn-label {
    font-size: 10px;
    letter-spacing: 1.5px;
    color: #bae6fd;
    font-weight: 700;
}

.whois-live-badge {
    font-size: 9px;
    color: #86efac;
    font-weight: 700;
    background: rgba(34,197,94,.12);
    padding: 7px 10px;
    border-radius: 20px;
}

.whois-asn-card h2 {
    font-size: 34px;
    font-weight: 800;
    color: #fff;
    margin: 17px 0 5px;
}

.whois-asn-card h5 {
    font-size: 14px;
    color: #e0f2fe;
    margin: 0;
    font-weight: 600;
}

.whois-asn-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    margin-top: 20px;
    color: #bae6fd;
    font-size: 11px;
}

/* SECTIONS */

.whois-section {
    margin-top: 20px;
    padding: 20px;
    background: rgba(15,23,42,.65);
    border: 1px solid rgba(148,163,184,.13);
    border-radius: 12px;
}

.whois-section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 15px;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(148,163,184,.12);
}

.whois-section-title span {
    font-size: 19px;
}

.whois-section-title h5 {
    margin: 0;
    color: #f1f5f9;
    font-size: 14px;
    font-weight: 700;
}

/* INFORMATION GRID */

.whois-info-grid {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: 12px;
}

.whois-info-item {
    min-width: 0;
    padding: 13px;
    background: #0b1423;
    border: 1px solid rgba(148,163,184,.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.whois-info-item > span {
    color: #64748b;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

.whois-info-item strong {
    color: #bae6fd;
    font-size: 12px;
    font-weight: 600;
    overflow-wrap: anywhere;
    line-height: 1.6;
}

/* CONTACT CARDS */

.whois-contact-grid {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: 15px;
}

.whois-contact-card {
    min-width: 0;
    background: #0b1423;
    border: 1px solid rgba(56,189,248,.15);
    border-radius: 10px;
    overflow: hidden;
}

.whois-contact-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    padding: 16px;
    background: rgba(14,165,233,.07);
    border-bottom: 1px solid rgba(148,163,184,.1);
}

.whois-contact-header h6 {
    margin: 0 0 6px;
    color: #f1f5f9;
    font-size: 12px;
    font-weight: 700;
    overflow-wrap: anywhere;
}

.whois-contact-header span {
    color: #38bdf8;
    font-size: 10px;
}

.whois-contact-icon {
    font-size: 20px !important;
}

.whois-contact-body {
    padding: 12px;
    display: grid;
    gap: 9px;
}

/* RDAP LINKS */

.whois-links {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 17px;
    padding-top: 15px;
    border-top: 1px solid rgba(148,163,184,.1);
}

.whois-links > span {
    color: #64748b;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
}

.whois-links a {
    color: #38bdf8;
    font-size: 11px;
    text-decoration: none;
    overflow-wrap: anywhere;
}

.whois-links a:hover {
    color: #7dd3fc;
    text-decoration: underline;
}

/* REGISTRATION HISTORY */

.whois-events {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.whois-event {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.whois-event-dot {
    width: 10px;
    height: 10px;
    min-width: 10px;
    margin-top: 4px;
    border-radius: 50%;
    background: #0ea5e9;
    box-shadow: 0 0 10px rgba(14,165,233,.5);
}

.whois-event strong {
    display: block;
    color: #e2e8f0;
    font-size: 12px;
    text-transform: capitalize;
}

.whois-event span {
    display: block;
    margin-top: 5px;
    color: #64748b;
    font-size: 11px;
}

/* ENTITIES */

.whois-entities {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;
}

.whois-entities span {
    padding: 9px 13px;
    color: #7dd3fc;
    background: rgba(14,165,233,.09);
    border: 1px solid rgba(56,189,248,.2);
    border-radius: 7px;
    font-size: 10px;
    font-weight: 600;
    overflow-wrap: anywhere;
}

/* FOOTER */

.whois-result-footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid rgba(148,163,184,.12);
    color: #64748b;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

/* RESPONSIVE */

@media(max-width:768px) {
    .whois-contact-grid {
        grid-template-columns: 1fr;
    }
}

@media(max-width:576px) {
    .whois-lookup {
        padding: 15px !important;
    }

    .whois-info-grid {
        grid-template-columns: 1fr;
    }

    .whois-section {
        padding: 13px;
    }

    .whois-asn-card {
        padding: 17px;
    }

    .whois-asn-card h2 {
        font-size: 28px;
    }

    .whois-asn-meta {
        gap: 10px;
    }

    .whois-lookup .input-group .btn {
        min-width: 85px;
        padding: 0 12px;
    }

    .whois-result-footer {
        font-size: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/WhoisLookup.css"],"names":[],"mappings":";AACA;;4CAE4C;;AAE5C;IACI,wBAAwB;IACxB,qDAAqD;IACrD,sCAAsC;IACtC,mBAAmB;IACnB,cAAc;IACd,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,iBAAiB;;AAEjB;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,mDAAmD;IACnD,YAAY;IACZ,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,aAAa;;AAEb;IACI,aAAa;IACb,mBAAmB;IACnB,2DAA2D;IAC3D,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,QAAQ;AACZ;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,eAAe;;AAEf;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["\n/* ==========================================\n   WHOIS PREMIUM RESULT DASHBOARD\n========================================== */\n\n.whois-lookup {\n    padding: 25px !important;\n    background: linear-gradient(145deg, #111827, #0b1220);\n    border: 1px solid rgba(56,189,248,.15);\n    border-radius: 16px;\n    color: #e2e8f0;\n    box-shadow: 0 12px 35px rgba(0,0,0,.2);\n    font-family: Inter, Arial, sans-serif;\n}\n\n.whois-lookup h4 {\n    color: #f8fafc;\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 22px;\n}\n\n/* SEARCH INPUT */\n\n.whois-lookup .input-group {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 10px;\n    padding: 7px;\n    background: #080f1c;\n    border: 1px solid #334155;\n    border-radius: 10px;\n}\n\n.whois-lookup .input-group .form-control {\n    display: block !important;\n    flex: 1 1 0% !important;\n    width: 1% !important;\n    min-width: 0 !important;\n    height: 44px;\n    padding: 0 14px;\n    background: transparent !important;\n    color: #fff !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.whois-lookup .form-control::placeholder {\n    color: #64748b !important;\n}\n\n.whois-lookup .input-group .btn {\n    flex: 0 0 auto !important;\n    width: auto !important;\n    min-width: 110px;\n    border: none;\n    border-radius: 8px !important;\n    background: linear-gradient(135deg,#0284c7,#2563eb);\n    color: white;\n    font-weight: 700;\n}\n\n/* RESULTS */\n\n.whois-results {\n    margin-top: 25px;\n    animation: whoisFade .35s ease;\n}\n\n@keyframes whoisFade {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n/* ASN HERO */\n\n.whois-asn-card {\n    padding: 25px;\n    border-radius: 13px;\n    background: linear-gradient(120deg,#0c4a6e,#172554,#312e81);\n    border: 1px solid rgba(56,189,248,.3);\n    margin-bottom: 20px;\n}\n\n.whois-asn-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.whois-asn-label {\n    font-size: 10px;\n    letter-spacing: 1.5px;\n    color: #bae6fd;\n    font-weight: 700;\n}\n\n.whois-live-badge {\n    font-size: 9px;\n    color: #86efac;\n    font-weight: 700;\n    background: rgba(34,197,94,.12);\n    padding: 7px 10px;\n    border-radius: 20px;\n}\n\n.whois-asn-card h2 {\n    font-size: 34px;\n    font-weight: 800;\n    color: #fff;\n    margin: 17px 0 5px;\n}\n\n.whois-asn-card h5 {\n    font-size: 14px;\n    color: #e0f2fe;\n    margin: 0;\n    font-weight: 600;\n}\n\n.whois-asn-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 18px;\n    margin-top: 20px;\n    color: #bae6fd;\n    font-size: 11px;\n}\n\n/* SECTIONS */\n\n.whois-section {\n    margin-top: 20px;\n    padding: 20px;\n    background: rgba(15,23,42,.65);\n    border: 1px solid rgba(148,163,184,.13);\n    border-radius: 12px;\n}\n\n.whois-section-title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding-bottom: 15px;\n    margin-bottom: 16px;\n    border-bottom: 1px solid rgba(148,163,184,.12);\n}\n\n.whois-section-title span {\n    font-size: 19px;\n}\n\n.whois-section-title h5 {\n    margin: 0;\n    color: #f1f5f9;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n/* INFORMATION GRID */\n\n.whois-info-grid {\n    display: grid;\n    grid-template-columns: repeat(2,minmax(0,1fr));\n    gap: 12px;\n}\n\n.whois-info-item {\n    min-width: 0;\n    padding: 13px;\n    background: #0b1423;\n    border: 1px solid rgba(148,163,184,.1);\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.whois-info-item > span {\n    color: #64748b;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n.whois-info-item strong {\n    color: #bae6fd;\n    font-size: 12px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n    line-height: 1.6;\n}\n\n/* CONTACT CARDS */\n\n.whois-contact-grid {\n    display: grid;\n    grid-template-columns: repeat(2,minmax(0,1fr));\n    gap: 15px;\n}\n\n.whois-contact-card {\n    min-width: 0;\n    background: #0b1423;\n    border: 1px solid rgba(56,189,248,.15);\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.whois-contact-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 16px;\n    background: rgba(14,165,233,.07);\n    border-bottom: 1px solid rgba(148,163,184,.1);\n}\n\n.whois-contact-header h6 {\n    margin: 0 0 6px;\n    color: #f1f5f9;\n    font-size: 12px;\n    font-weight: 700;\n    overflow-wrap: anywhere;\n}\n\n.whois-contact-header span {\n    color: #38bdf8;\n    font-size: 10px;\n}\n\n.whois-contact-icon {\n    font-size: 20px !important;\n}\n\n.whois-contact-body {\n    padding: 12px;\n    display: grid;\n    gap: 9px;\n}\n\n/* RDAP LINKS */\n\n.whois-links {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 17px;\n    padding-top: 15px;\n    border-top: 1px solid rgba(148,163,184,.1);\n}\n\n.whois-links > span {\n    color: #64748b;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n.whois-links a {\n    color: #38bdf8;\n    font-size: 11px;\n    text-decoration: none;\n    overflow-wrap: anywhere;\n}\n\n.whois-links a:hover {\n    color: #7dd3fc;\n    text-decoration: underline;\n}\n\n/* REGISTRATION HISTORY */\n\n.whois-events {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.whois-event {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.whois-event-dot {\n    width: 10px;\n    height: 10px;\n    min-width: 10px;\n    margin-top: 4px;\n    border-radius: 50%;\n    background: #0ea5e9;\n    box-shadow: 0 0 10px rgba(14,165,233,.5);\n}\n\n.whois-event strong {\n    display: block;\n    color: #e2e8f0;\n    font-size: 12px;\n    text-transform: capitalize;\n}\n\n.whois-event span {\n    display: block;\n    margin-top: 5px;\n    color: #64748b;\n    font-size: 11px;\n}\n\n/* ENTITIES */\n\n.whois-entities {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 9px;\n}\n\n.whois-entities span {\n    padding: 9px 13px;\n    color: #7dd3fc;\n    background: rgba(14,165,233,.09);\n    border: 1px solid rgba(56,189,248,.2);\n    border-radius: 7px;\n    font-size: 10px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n}\n\n/* FOOTER */\n\n.whois-result-footer {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 20px;\n    padding-top: 15px;\n    border-top: 1px solid rgba(148,163,184,.12);\n    color: #64748b;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n/* RESPONSIVE */\n\n@media(max-width:768px) {\n    .whois-contact-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media(max-width:576px) {\n    .whois-lookup {\n        padding: 15px !important;\n    }\n\n    .whois-info-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .whois-section {\n        padding: 13px;\n    }\n\n    .whois-asn-card {\n        padding: 17px;\n    }\n\n    .whois-asn-card h2 {\n        font-size: 28px;\n    }\n\n    .whois-asn-meta {\n        gap: 10px;\n    }\n\n    .whois-lookup .input-group .btn {\n        min-width: 85px;\n        padding: 0 12px;\n    }\n\n    .whois-result-footer {\n        font-size: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
